import { DeleteUserRequest, DeleteUserResponse } from '../deleteuser';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceUrl } from '../utils/api';

export async function deleteUser(
    request: DeleteUserRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<DeleteUserResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = DeleteUserRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const url = getServiceUrl('adminservice', 'deleteuser');

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): DeleteUserResponse => {
        return DeleteUserResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
